module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_bird-48fefaab4cb91418a961517cd6dc99a3.png";